module.exports = __webpack_public_path__ + "static/img/logo26.7b70092.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo26.png
// module id = 6xAb
// module chunks = 1